//
// Хук для запроса к API
//
import { useState, useEffect } from 'react';
import { get, post, put, del, ApiResponse, ApiResponseError, ApiResponseErrorUnknown } from '../utils/api';

export type ApiError = {
    code: number,
    text: {
        ru: string,
        en: string,
    },
};

export type UseApi = (
    type: 'get' | 'post' | 'put' | 'delete',
    method: string,
    params?: object,
) => [
    data: object | null,
    error: ApiError | null,
    isLoading: boolean,
];

const useApi: UseApi = ( t, m, p = {} ) => {
    // eslint-disable-next-line 
    const [ type, setType ] = useState(t);
    // eslint-disable-next-line 
    const [ method, setMethod ] = useState(m);
    // eslint-disable-next-line 
    const [ params, setParams ] = useState(p);
    const [ data, setData ] = useState<object | null>(null);
	const [ error, setError ] = useState<ApiResponseError | null>(null);
	const [ isLoading, setIsLoading ] = useState(false);

	useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            setData(null);
            setError(null);
            let result: ApiResponse | null;

            switch(type) {
                case 'get':
                    result = await get(method, params);
                    break;
                case 'post':
                    result = await post(method, params);
                    break;
                case 'put':
                    result = await put(method, params);
                    break;
                case 'delete':
                    result = await del(method, params);
                    break;
                default:
                    result = null;
                    break;
            }

            if(result) {
                if(result.data) setData(result.data);
                if(result.error) setError(result.error);
            } else {
                setError(ApiResponseErrorUnknown);
            }

            setIsLoading(false);
        }

        fetchData();
	}, [type, method, params]);

    return [ data, error, isLoading ];
};

export default useApi;
